import { StyleGroupDefinition, StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [];

export const styleDefaults = new Map<string, string>();

export const stylePropertiesForTheme: Array<StylePropertyDefinition> = [];
